import LogSearch from './LogSearch';

export default function SprLogs() {
    return <LogSearch defaultPattern="SPR-*" lockPattern={false} title="SPR Logs" />;
}
